module.exports = __webpack_public_path__ + "img/sample_yingyezhizhao1.802f0ffe.png";